// extracted by mini-css-extract-plugin
module.exports = {"sso":"form_sso__DBaQ7","captchaError":"form_captchaError__KI2E6","notice":"form_notice__1iwDr"};